import { all } from "redux-saga/effects";
import { getActivityLogsWatcher } from "./getActivityLogs.saga";
import { getHistoryUsersWatcher } from "./getHistoryUsers.saga";

export default function* rootSaga() {
    yield all([getActivityLogsWatcher(), getHistoryUsersWatcher()]);
}
